function setProducts(data) {
	return {
		type: 'SET_PRODUCTS',
		payload: data,
	};
}

export { setProducts };
